import { MutationTree } from 'vuex';
import { State } from './mobileCommon.store';
import store from '@/store/index';
import { CAPABILITY_MOBILE } from '@/utils/constants';
import { NAVTABS } from '@/utils/templates/mobile/mobile.constants';

const mutations: MutationTree<State> = {
  setMobileTab(state, tabName) {
    switch (tabName) {
      case NAVTABS.MOBILE_KPI_USAGE_TAB:
        state.currentTab = 'Usage';
        break;
      case NAVTABS.MOBILE_KPIS_CRASHES_TAB:
        state.currentTab = 'Crashes';
        break;
      case NAVTABS.MOBILE_KPIS_PERFORMANCE_TAB:
        state.currentTab = 'Performance';
        break;
      default:
        state.currentTab = 'MobileDashboard';
        break;
    }
  },

  setMobileServices(state: State, data: any) {
    state.mobileServices = data;
    if (
      (!state.currentMobileService.key && data.length) ||
      state.currentMobileService.key === 'all'
    ) {
      state.currentMobileService = data[0];
    }
  },
  setMobileOS(state: State, data: any) {
    state.mobileOSs = data;
    if (!state.currentMobileOS.key && data.length) {
      state.currentMobileOS = state.mobileOSs[0];
    }
  },
  setMobileAppVersion(state: State, data: any) {
    let _allVersionEntry: any[] = [];
    if (state.currentMobileOS.key === "IOS") {
      _allVersionEntry = [{ key: 'all', label: 'All' }, ...state.allIOSAppVersions];
    } else if (state.currentMobileOS.key === "ANDROID") {
      _allVersionEntry = [{ key: 'all', label: 'All' }, ...state.allAndroidAppVersions];
    } else {
      _allVersionEntry = [{ key: 'all', label: 'All' }, ...data];
    }
    state.mobileAppVersions = _allVersionEntry;
    if (!state.currentMobileAppVersion.key && data.length) {
      state.currentMobileAppVersion = state.mobileAppVersions[0];
    }
  },

  //Sets the current service in rootState
  setCurrentMobileService(state: State, service: any) {
    state.currentMobileService = service;
    state.currentMobileAppVersion = state.mobileAppVersions[0];
    store.commit('globalState/app/setUpdateDasboard', service, { root: true });
  },
  setCurrentMobileOS(state: State, OS: any) {
    state.currentMobileOS = OS;
    let _allVersionEntry: any[] = [];
    if (OS.key === "all") {
      _allVersionEntry = [{ key: 'all', label: 'All' }, ...state.allIOSAppVersions, ...state.allAndroidAppVersions];
    }
    if (OS.key === "IOS") {
      _allVersionEntry = [{ key: 'all', label: 'All' }, ...state.allIOSAppVersions];
    }
    if (OS.key === "ANDROID") {
      _allVersionEntry = [{ key: 'all', label: 'All' }, ...state.allAndroidAppVersions];
    }
    state.mobileAppVersions = _allVersionEntry;
    state.currentMobileAppVersion = state.mobileAppVersions[0];
    store.commit('globalState/app/setUpdateDasboard', OS, { root: true });
  },
  setCurrentMobileAppVersion(state: State, version: any) {
    state.currentMobileAppVersion = version;
    store.commit('globalState/app/setUpdateDasboard', version, { root: true });

  },
  setAllIOSAppVersions(state: State, data: any) {
    state.allIOSAppVersions = data;
  },
  setAllAndroidAppVersions(state: State, data: any) {
    state.allAndroidAppVersions = data;
  },
  
  // resets to default values on logout
  setDefaultValues(state: State, data: any) {
    state.currentTab = NAVTABS.MOBILE_KPIS_CRASHES_TAB;
    state.capability = CAPABILITY_MOBILE;
    state.mobileServices = [];
    state.mobileAppVersions = [];
    state.mobileOSs = [];
    state.currentMobileService = {};
    state.currentMobileOS = {};
    state.currentMobileAppVersion = {};
    state.allAndroidAppVersions = [];
    state.allIOSAppVersions = [];
  },
};

export default mutations;
